import React, { Component } from 'react';
import { campoTipoServico } from '../../util/constantsUtil';

export default class CheckboxGroupTipoServico extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkedState: this.carregar()
    }
  }

  carregar() {
    if (this.props.tipoServico) {
      const updatedCheckedState = campoTipoServico.map(it => {
        const array = this.props.tipoServico;
        if (array.filter(tipo => tipo.chave === it.chave).length > 0) {
          return true;
        }

        return false;
      })

      return updatedCheckedState;
    }

    return new Array(campoTipoServico.length).fill(false)
  }

  handleOnChange(position) {
    const updatedCheckedState = this.state.checkedState.map((item, index) =>
      index === position ? !item : item
    );

    this.props.handleValues(updatedCheckedState.map((item, index) => {
      if (item) {
        return campoTipoServico[index];
      }
    }));

    this.setState({ checkedState: updatedCheckedState });

  }

  render() {
    return (
      <>
        <h3>Serviços</h3>
        <div className='campoTipoServico-container'>
          <ul className="campoTipoServico-list">
            {campoTipoServico.map(({ chave, valor }, index) => {
              return (
                <li key={index}>
                  <div className="campoTipoServico-list-item">
                    <div className="left-section">
                      <input
                        type="checkbox"
                        id={`custom-checkbox-${index}`}
                        name={valor}
                        value={chave}
                        checked={this.state.checkedState[index]}
                        onChange={() => this.handleOnChange(index)}
                      />
                      <label htmlFor={`custom-checkbox-${index}`}>{valor}</label>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </>
    )
  }
}